import React from 'react';
import ReactDOM from 'react-dom';
import './_layout';
import SkillSearch from '../components/SkillSearch';
var rootUrl = (window.globals && window.globals.rootUrl) || "../";

var canEdit = window.globals.canPost;
var canDelete = canEdit;

fetch(rootUrl + 'API/GetSkills', {
	method: 'GET',
	headers: {
		"Accept": "application/json, text/plain, */*",
		"Content-Type" : "application/json"
	}
}).then(function(response){
	return response.json();
}).then(function(skills){
	if (skills !== null) {
    ReactDOM.render(<SkillSearch 
      rootUrl={rootUrl}
			skills={skills} 
			canEdit={canEdit}
			deleteSkill={deleteSkill}
			canDelete={canDelete} />, document.getElementById('skill-list'));
	} else {
		alert('Network call failed.');
	}
});

function deleteSkill(id, name) {
	var reallyDelete = confirm("Really delete skill " + unescape(name) + "?");
    if (reallyDelete) {
      fetch(rootUrl + 'API/DeleteSkill', {
        method: 'POST',
        headers: {
          "RequestVerificationToken": globals.csrfToken,
          "Accept": "application/json, text/plain, */*",
          "Content-Type" : "application/json"
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          Id: id
        })
      }).then(function(resultSuccess){
        if (resultSuccess.ok) {
          window.location.reload(true);
        } else {
          alert('Delete failed');
        }
      });
    }
}